import { render, staticRenderFns } from "./BSpinner.vue?vue&type=template&id=22966684&"
import script from "./BSpinner.vue?vue&type=script&lang=ts&"
export * from "./BSpinner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports